import React from 'react'

import { CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, string } from 'prop-types'

import { iconSize, MODE } from 'Pods/LazyLoaded/AuthModal/constants'

function SuccessStep({ mode, email }) {
  const isLogin = mode === MODE.LOGIN

  return (
    <div className="auth-modal__success">
      <span className="auth-modal__success-icon">
        <Icon svgComponent={CircleCheck} size={iconSize} notSpaced />
      </span>
      <div className="auth-modal__header-group auth-modal__header-group--center">
        <p className="auth-modal__title cgt-heading-300">
          {isLogin ? 'Welcome back' : "You're in"}
        </p>
        <p className="auth-modal__subtitle cgt-body-md">
          {isLogin ? (
            <>
              Signed in as
              {' '}
              <span className="auth-modal__email cgt-body-md-semibold">{email.trim()}</span>
            </>
          ) : (
            "Account created. Let's find your next model."
          )}
        </p>
      </div>
    </div>
  )
}

SuccessStep.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]).isRequired,
  email: string.isRequired,
}

export default SuccessStep
